import { apiPostPhysicians } from "../../../api";
import { ApiConnector } from "../../../api/api-connector";
import { DataAdd } from "../../../models/data-add";
import { splitNameArray } from "../../../utils/names";

export class AddPhysician extends DataAdd<null> {
  constructor(api: ApiConnector) {
    super(api, null);
    this.addingList = {
      given_name: null,
      family_name: null,
      middle_names: null,
      name_particle: null,
      additional_family_names: null,
      name_suffix: null,
      title_before: null,
      title_after: null,
      name_order_given_first: true,
      country: null,
      region: 0,
      email: null,
      phone: [],
      connected_user_uuid: null,
      clinics_uuids: [],
      patient_ids: [],
      // Read field is `assigned_monitoring_users`; create field is `assigned_users_uuids`.
      assigned_users_uuids: [],
    };
  }

  async post(phones: string[] = []): Promise<string | null> {
    this.addingList["phone"] = phones;

    const response = await apiPostPhysicians({
      body: {
        ...this.addingList,
        middle_names: splitNameArray(this.addingList.middle_names),
        additional_family_names: splitNameArray(
          this.addingList.additional_family_names,
        ),
      },
    });

    if (response.data != null) {
      this.api.clearResponseCache();
      return response.data.uuid;
    }
    return null;
  }
}
